import { fetchTransport } from 'util/core/transport/fetch.transport'
import { type MarketClassificationInterface } from './type/market-classification-type'
import { checkFetchError } from 'util/core/tool/check-fetch-error'
// import * as AllJson from './json/all.json'

class DataAccessClassifications {
  public async getAll (): Promise<{ total: number, items: MarketClassificationInterface[] }> {
    // const json = JSON.parse(JSON.stringify(AllJson)) as any
    const response = await fetchTransport.get({
      url: '/api/market_classification/all'
    })

    checkFetchError(response.status)

    const json = await response.json()
    const result = {
      items: [],
      total: 0
    }

    if (json['@type'] === 'hydra:Collection') {
      if (json['hydra:member'].length > 0) {
        const items = json['hydra:member']
        result.total = json['hydra:totalItems']
        result.items = items.map((item: MarketClassificationInterface) => item)
      }
    }

    return result
  }

  public async getClassification (id: string): Promise<MarketClassificationInterface> {
    const response = await fetchTransport.get({
      url: `/api/market_classifications/${id}`
    })

    checkFetchError(response.status)

    const json = await response.json()

    return json
  }
}

export const dataAccessClassifications = new DataAccessClassifications()
